//manage url params

import qs from "qs";
import {ADD_DOMAIN_PAGE, ADD_PRODUCT_PAGE, EDIT_DOMAIN_PAGE, EDIT_PRODUCT_PAGE} from "./common";

export const getDataFromURL = (search) => {
    if (search && typeof search.replace === "function") {
        const params = qs.parse(search.replace('?', ''))
        return params
    }
    return null
}

export const getPageByURL = (search) => {
    const { a, pid, uuid, domain, query } = getDataFromURL(search)
    if (a === 'add' && pid) {
        return (ADD_PRODUCT_PAGE)
    }
    if (a === 'edit' && uuid) {
        return (EDIT_PRODUCT_PAGE)
    }
    if (a === 'confdomain' && uuid) {
        return (EDIT_DOMAIN_PAGE)
    }
    if (a === 'add' && domain && query) {
        return (ADD_DOMAIN_PAGE)
    }
    return undefined
}

export const getCurrentStep = (configurations, cid) => {
    if (configurations && cid && configurations[cid] && configurations[cid].step) {
        return configurations[cid].step
    }
    return 0
}

export const getCID = (urlparams) => {
    const { a, pid, uuid } = urlparams
    if (a === 'edit' && uuid) {
        return uuid
    }
    if (a === 'add' && pid) {
        return pid
    }
    return null
}

export const getPromo = (location) => {
    //get promo from URL
    const { promo } = getDataFromURL(location.search)
    return promo
}